// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3wF7D","header":"ReportDetails_header__2QW6G","title":"ReportDetails_title__2Gx-n","left":"ReportDetails_left__3Tjq3"};